import { useContext } from 'react';

import { WizardContext } from '../context';
import { WizardValues } from '../types';

const fallback: WizardValues = {
  nextStep: () => {},
  prevStep: () => {},
  goToStep: () => {},
  hasNextStep: false,
  hasPrevStep: false,
  isFirstStep: true,
  isLastStep: true,
  currentStep: 0,
  activeStep: 0,
  steps: [],
};

export const useStepWizard = (): WizardValues => {
  const context = useContext(WizardContext);

  if (!context) {
    return fallback;
  }

  return context;
};
